export var SITE_FEATURE_FLAGS;
(function (SITE_FEATURE_FLAGS) {
    SITE_FEATURE_FLAGS["PARTICIPANT_RESPONSES_TAB"] = "ParticipantResponsesTab";
})(SITE_FEATURE_FLAGS || (SITE_FEATURE_FLAGS = {}));
